/// <reference path='docs-and-forms.module.ts' />
///<reference path="docs-and-forms.models.ts"/>
/// <reference path='../../../../typings/index.d.ts' />
///<reference path="../../components/baseClasses/dataMaintenance.interface.ts"/>

module Meevo.Plugins.DocsAndForms {

    import AppAreaEnum = Meevo.Model.AppAreaEnum;

    export enum FormGroupBy {
        Service = 1
    }

    interface IClientFormRequest {
        clientId: string;
    }


    interface IAppointmentServiceFormRequest {
        AppointmentServicesList: string[];
        TriggerEventEnum: Meevo.Model.DocsAndFormsTriggerEventEnum;
        isBuilt: boolean;
    }

    interface IUsedResponse {
        isUsed: boolean;
        hasFormAppointmentServices: boolean;
        hasPDFs: boolean;
    }

    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import FormTypeEnum = Meevo.Model.FormTypeEnum;

    export class DocsAndFormsApiService {
        private assignedUDFs: IUserDefinedControl[];
        private cache: _.Dictionary<any>;

        static factory(): Function {
            const instance = (appSettings: Meevo.Components.Common.IAppSettings,
                              dataService: Meevo.Components.BaseClasses.IDataService,
                              $translate: angular.translate.ITranslateService,
                              $q: angular.IQService) => {
                return new DocsAndFormsApiService(appSettings, dataService, $translate, $q);
            };

            instance.$inject = [
                'meevo.AppSettings',
                'meevo.components.common.DataService',
                '$translate',
                '$q'
            ];

            return instance;
        }

        static assignControlToFormProcess(dataService: Meevo.Components.BaseClasses.IDataService, controls: IUserDefinedControl[], form: IDocsAndFormsModel) {
            return dataService.add(`CustomData/Tab`, {
                tab: form,
                controls
            });
        }

        static getDocsAndFormsModelByIdProcess(dataService: Meevo.Components.BaseClasses.IDataService, id: Guid): ng.IPromise<IDocsAndFormsModel> {
            return (<any>dataService.getItem('DocsAndForms/Form', id));
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: angular.IQService) {
            this.assignedUDFs = [];
            this.cache = {};
        }

        public assignControlToForm(controls: IUserDefinedControl[], form: IDocsAndFormsModel) {
            return DocsAndFormsApiService.assignControlToFormProcess(this.dataService, controls, form);
        }

        public removeCustomFormField(entityVersion: number, control_TId: Guid): ng.IPromise<any> {
            return this.dataService.patch('CustomData/Control', {
                Model: {
                    entityVersion: entityVersion,
                    objectStateEnum: ObjectStateEnum.Deleted
                }
            }, control_TId);
        }
        
        public undeleteCustomFormField(entityVersion: number, control_TId: Guid): ng.IPromise<any> {
            return this.dataService.patch('CustomData/Control', {
                Model: {
                    entityVersion: entityVersion,
                    objectStateEnum: ObjectStateEnum.Active
                }
            }, control_TId);
        }
        public getDocsAndFormsModelById(id: any): ng.IPromise<IDocsAndFormsModel> {
            return DocsAndFormsApiService.getDocsAndFormsModelByIdProcess(this.dataService, id);
        }

        public getAssignedUDFs(formId: string, formType: FormTypeEnum): ng.IPromise<IUserDefinedControl[]> {

            return this.dataService.getListPaged('DocsAndForms/FormControl', <any>{
                formId: formId,
                criteria: {
                    includeControls: true,
                    includeItems: true,
                    tabTypeEnum: formType
                }
            }).then((SDFs: Meevo.Model.IUserDefinedControl[]) => {
                return this.dataService.getListPaged<IUserDefinedControl, any>('CustomData/AppAreaControl', <any>{
                    appAreaEnum: AppAreaEnum.Client,
                    IncludeControls: true,
                    IncludeItems: true
                }).then((UDFs: Meevo.Model.IUserDefinedControl[]) => {
                    const data = [...SDFs, ...UDFs]
                        .filter((row) => row.controlTypeEnum !== ControlTypeEnum.ImageUpload && row.controlTypeEnum !== ControlTypeEnum.DocumentUpload);

                    this.assignedUDFs = data;

                    return data;
                });
            });
        }

        public getSubmitedFormsByClientId(clientId: string, formFillType: FormFillTypeEnum): ng.IPromise<IClientForm[]> {
            return this.dataService.getListPaged('DocsAndForms/GroupedClientForm', <any>{
                clientId,
                formFillTypeEnum: formFillType === FormFillTypeEnum.All ? null : formFillType
            });
        }

        public getClientFormList(request: IClientFormRequest): ng.IPromise<IClientFormService[]> {
            return this.dataService.getListPaged<IClientFormService, any>('DocsAndForms/ClientForm', <any>request);
        }

        public getAppointmentServiceFormList(request: IAppointmentServiceFormRequest): ng.IPromise<IClientFormService[]> {
            return this.dataService.getListPaged<IClientFormService, any>('DocsAndForms/AppointmentServiceForm', <any>request);
        }

        public getFormServiceConfig(servicesIds: string[]): ng.IPromise<IFormServiceConfig[]> {
            return this.dataService.customMethodData(
                `${this.appSettings.API_ROOT}/DocsAndForms/AppointmentServiceForm/Check`,
                'POST',
                { AppointmentServicesList: servicesIds }
            ).then((res) => res.data);
        }

        public resendForm({ clientId, formId, appointmentId, appointmentServiceId }) {
            return this.dataService.add('DocsAndForms/ResendClientForm', {
                clientId,
                formId, // form.id matches id used by Client Docs & Forms resendForm method
                appointmentId,
                appointmentServiceId
            });
        }

        public formIsUsed(formId: string): ng.IPromise<IUsedResponse> {
            const cacheKey = `${formId}-idUsed`;
            if (!!this.cache[cacheKey]) {
                return this.$q.resolve(this.cache[cacheKey]);
            }

            return this.dataService.getItem('DocsAndForms/Form/Usage', formId as any)
                .then((res) => {
                    this.cache[cacheKey] = res;

                    return res;
                });

        }

        // AttachmentUrl is gone: it was a caller-chosen link into a world-readable bucket,
        // copied verbatim into the email. The server now mints an OTP-gated single-document
        // link from these ids, with the tenant taken from the session. Keep in step with the
        // Web.Hub sender in libs/xplat/features/.../docs-and-forms.service.ts.
        public sendWithEmail({ email, clientId, displayName, formTabId, formPdfId }) {
            return this.dataService.add('DocsAndForms/EmailClientForm', {
                EmailTo: email,
                ClientId: clientId,
                FormDisplayName: displayName,
                FormTab_TId: formTabId,
                FormPDF_TId: formPdfId,
            });
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .service('meevo.plugins.docsAndForms.DocsAndFormsApiService', DocsAndFormsApiService.factory());
}
